import { useMemo } from 'react';
import { colors, Icon, Spinner, Button } from '@iq/react-components';

import DegradedQualityIndicator from '../shared/DegradedQualityIndicator';
import { getActiveStates } from '../../../../../bundles/statesets';
import LabelWithTooltip from '../../../../LabelWithTooltip';

const StateVisualization = ({
  isPreview = false,
  visualization,
  disconnected,
  latestValues: values,
  loading: loadingOverride,
}) => {
  const { configuration = {}, variables } = visualization;
  const loading = loadingOverride ?? !values;
  const statefulVariablesWithValues = useMemo(
    () =>
      variables
        .filter((v) => v.stateset)
        .map((v) => {
          const variableData = values?.find((value) => value.variable === v.id);
          const lastValue = Number.isNaN(variableData?.value.at(-2))
            ? null
            : variableData?.value.at(-2);
          const lastValueQuality = variableData?.value.at(-1) || 2;

          return { ...v, value: lastValue, quality: lastValueQuality };
        }),
    [values, variables]
  );
  const activeStates = getActiveStates(statefulVariablesWithValues);

  // invalidate if quality !== 1 (valid) or no data connectivity (disconnected)
  const isDataInvalid =
    statefulVariablesWithValues.some((value) => value.quality > 1) || disconnected;

  const getIcon = (states) => {
    if (states.length === 0) {
      return (
        <Icon
          icon="he-status"
          size="s"
          style={{ color: colors.Grey50 }}
        />
      );
    }
    if (states.length === 1) {
      return (
        <>
          <Icon
            icon="he-status"
            size="s"
            style={{ color: states[0].color }}
          />
          <p className="state-text">{states[0].text}</p>
        </>
      );
    }
    return (
      <Icon
        icon="he-help"
        size="s"
        style={{ color: colors.StatusRed }}
      />
    );
  };

  return (
    <div
      className={`state-visualization-component ${isPreview ? 'preview' : 'normal'} ${
        isDataInvalid ? 'invalid-data' : ''
      }`}
    >
      <div className="wrapper">
        {loading ? <Spinner /> : getIcon(activeStates)}
        <div className="label">
          <LabelWithTooltip name={configuration?.label || visualization?.name || '\u00A0'} />
          {isDataInvalid ? <DegradedQualityIndicator /> : null}
        </div>
      </div>
    </div>
  );
};

export default StateVisualization;
